export const REMEMBER_ACCOUNTS_EXPERIMENT = 'aud_1403_remember_accounts_flow';
export const DEAL_RENT_HEADER_NEW_ITEM = 'deal_rent_head_new_item';
export const PND_NEW_FLOW_EXPERIMENT = 'pnd_new_flow';

export const EXPERIMENTS = [REMEMBER_ACCOUNTS_EXPERIMENT, DEAL_RENT_HEADER_NEW_ITEM];
